import { GlobalAuthState } from '@cibo/core'
import { CiboUiContext, ROUTE } from '@cibo/ui'
import { useQueryClient } from '@tanstack/react-query'
import qs from 'query-string'
import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks'

export const AuthCheck = () => {
  const { isLoggedIn, sessionValid, userToken, logout, checkAuth, invalidateSession } = useAuth()
  const { events } = useContext(CiboUiContext)
  const queryClient = useQueryClient()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoggedIn) {
      events.dispatchEvent(new CustomEvent('close_modals'))
      queryClient.clear()
    }
    const mostRecentLocation = GlobalAuthState.mostRecentLocation()
    if (isLoggedIn && !!mostRecentLocation) {
      mostRecentLocation.pathname !== ROUTE.ACCOUNT_LOGOUT && navigate(mostRecentLocation)
      GlobalAuthState.setMostRecentLocation(undefined)
    }
  }, [isLoggedIn])

  if (sessionValid && !GlobalAuthState.isAuthorized()) {
    window.localStorage.setItem('landManager', JSON.stringify({}))
    logout(location)
  }

  useEffect(() => {
    // look for auth0 token in url param
    const { id_token } = window.location
      ? (qs.parse(window.location.hash) as { id_token: string })
      : ({} as { id_token: undefined })

    if (id_token && typeof id_token === 'string') {
      checkAuth({ jwt: id_token, location })
    } else if (userToken) {
      checkAuth({ jwt: userToken, location }) // look for stored auth token in store
    } else {
      invalidateSession() // no auth token found - resolve invalid session
    }
  }, [])

  return null
}
